import { Box, Container, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";

const OurImpact = () => {
  return (
    <Box width={"100vw"} mb={10}>
      <Container
        sx={{
          /* bgcolor: "primary.main", */
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          py: 5,
          borderRadius: 5,
        /* background: "radial-gradient(circle, #f5f5f5, #DB5430)", */
        border: "1px solid #DB5430",
        }}
      >
        <Box width={"90%"} color="#222222">
          <Typography variant="h2" mb={2.5}>Our Impact</Typography>
          <Typography>
            Too often we assume children need more support and help, more
            motivation and coaxing to learn than they do. Yet, if given the
            chance to learn within their zone of proximal development, children
            often demonstrate surprising responses, taking the opportunities
            with both hands. What started as an experiment in a community, has
            since become a more developed strategy to address the need for
            education within Zimbabwe and across Africa. It has also since
            developed into not only an educational platform but an enriching
            learning space, creating opportunities for all ages to grow in
            productivity and professionalism with a holistic perspective. What
            started as a story of 2 hopeless girls has become a catalyst for
            EAGLE to give hope, bring light to children’s eyes, and shape the
            future of countries.
          </Typography>
          <Box>
            <CustomButton sx={{ my: "1rem", bgcolor: "primary.main", color: "#fff" }}>
              <Typography>Join us today</Typography>
              <ChevronRightRounded />
            </CustomButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default OurImpact;
